import React from 'react';
export function TestimonialsSection() {
  return <section className="py-10 bg-alt border-y border-[#D9D0C1]" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="text-center mb-10" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-4" data-id="element-181">
            Mujeres reales. Sin exposición.
          </h2>
          <p className="text-body" data-id="element-182">
            Resultados distintos, misma idea: privacidad primero.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-183">
          {/* Testimonial 1 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-184">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-185">
              "Tenía pánico a que mis compañeros me vieran. Monté una cuenta
              anónima y ahora tengo una vía extra sin que nadie lo sepa."
            </p>
            <div className="flex items-center" data-id="element-186">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 overflow-hidden" data-id="element-187">
                <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Laura" className="w-full h-full object-cover grayscale opacity-80" data-id="element-188" />
              </div>
              <div data-id="element-189">
                <p className="font-medium text-title text-sm" data-id="element-190">Laura</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-191">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-192">
              "Soy introvertida. La cámara me bloqueaba. Con este método tengo
              estructura y publico sin ansiedad."
            </p>
            <div className="flex items-center" data-id="element-193">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 overflow-hidden" data-id="element-194">
                <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Carmen" className="w-full h-full object-cover grayscale opacity-80" data-id="element-195" />
              </div>
              <div data-id="element-196">
                <p className="font-medium text-title text-sm" data-id="element-197">Carmen</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-198">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-199">
              "No es un curso vendehumo. Es una guía práctica para empezar con
              orden."
            </p>
            <div className="flex items-center" data-id="element-200">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 overflow-hidden" data-id="element-201">
                <img src="https://randomuser.me/api/portraits/women/33.jpg" alt="Elena" className="w-full h-full object-cover grayscale opacity-80" data-id="element-202" />
              </div>
              <div data-id="element-203">
                <p className="font-medium text-title text-sm" data-id="element-204">Elena</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}